import React, { Component } from 'react';
import { 
   Menu, Loader,Button, Input, Segment
} from 'semantic-ui-react';
import printJS from 'print-js';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { BaseURLDev, headers } from '../../_utils/config';
import swal from 'sweetalert';
import { terbilang } from '../../_utils/terbilang';
import { toIDR } from '../../_utils/tocurrency';
import Barcode from 'react-barcode';
import { fetchOPD,fetchSKPD } from '../../_utils/localstorage';

export default class DashboardBank extends Component {
      constructor(props){
            super(props);
            this.state = {
                  data: null,
                  requests: false,
                  q: "", 
                  disable_btn: true
            }

            this.printSTS = this.printSTS.bind(this)
            this.showDetailSTS = this.showDetailSTS.bind(this)
      }

   getDataOPD(){
      fetch(`${BaseURLDev}/simantra/ref/allopd`)
      .then(response => {
         if(!response.ok){
            swal("Mohon periksa koneksi internet anda", {
               icon: "error",
            });
            return Promise.reject(response.statusText);

         }
         return response.json()
      })
      .then(resJSON => {
         var { skpd, user } = JSON.parse(sessionStorage.data);
         sessionStorage.setItem('data', JSON.stringify({
            user: user,
            opd: resJSON.data,
            skpd: skpd
         }))
      })
   }

   getDataSKPD(){
      fetch(`${BaseURLDev}/simantra/ref/allskpd`)
      .then(response => {
         if(!response.ok){
            swal("Mohon periksa koneksi internet anda", {
               icon: "error",
            });
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => {
         var { opd, user } = JSON.parse(sessionStorage.data);
         sessionStorage.setItem('data', JSON.stringify({
            user: user,
            opd: opd,
            skpd: resJSON.data,
         }))
      })
   }
   
   componentWillMount(){
      if(fetchSKPD().length===0 || fetchOPD().length===0){
         this.getDataSKPD()
         this.getDataOPD()
      }
   }
   printSTS() {
      printJS({
         printable:'data_print', 
         type: 'html', 
         showModal: true
      })
   }

   searchSts(query) {
      if(query===null || query==="" || query.length<10){
         this.setState({requests:false, disable_btn:true});
         swal("Masukkan nomor STS yang benar", {
            icon: "error",
         }).then(()=>{
            this.codeInput.focus();
         });
      }else{
         this.setState({requests:true});
         fetch(`${BaseURLDev}/sts?q=${query}&query=bank`,{headers})
         .then(response => {
            if(!response.ok){
               this.setState({data:null,requests:false, disable_btn:true});
               swal("Verifikasi STS gagal", {
                  icon: "error",
               });
               return Promise.reject(response.statusText);
            }
            return response.json()
         })
         .then(resJSON => {
            if(resJSON.data===null){
               this.setState({requests:false, disable_btn:true});
               swal(`${resJSON.messages}`, {
                  icon: "error",
               }).then(()=>{
                  this.codeInput.focus();
               });
            }else{
               this.setState({requests:false, data:resJSON.data, disable_btn:false});
            }
         });
      }
   }
   
   showDetailSTS(data){
      const styletb = {
         borderCollapse:'collapse',
         borderSpacing:0,
         borderStyle:'solid',
         width:'100%',
      }
      
      var count = 0;
      var counter = 0;

      if(data!==null){
         data.bp.map((item,i)=>(
            item.rincian.map((rek,ii)=>(
               count = count + rek.nilai
         ))))
      }
      
      return(
         <Segment loading={this.state.requests}>
         <div id="data_print">
            <div className="barcode" style={{float:"right"}}>
               <Barcode value={data['no_sts']}
                  height="40"
                  fontSize="13"
                  width={1}
               />   
            </div>
            <table align="center" width="100%" style={{fontSize:'14px'}}>
               <tbody>
                  <tr align="center">
                     <th colSpan="2">
                        <p style={{fontSize:'18px',marginBottom: '25px'}}>PEMERINTAH PROVINSI NUSA TENGGARA BARAT<br />
                        SURAT TANDA SETORAN (STS)</p>
                     </th>
                  </tr>
                  <tr>
                     <td width="30%">Nomor STS</td>
                     <td className="leftAlign" align="left">&nbsp;:&nbsp;{data['no_sts']}</td>
                  </tr>
                  <tr>
                     <td width="30%">BANK NTB</td>
                     <td className="leftAlign" align="left">&nbsp;:&nbsp;00121 05807 006</td>
                  </tr>
                  <tr>
                     <td width="30%">Harap diterima uang</td>
                     <td className="leftAlign" align="left">&nbsp;:&nbsp;
                        {toIDR(count)}
                     </td>
                  </tr>
                  <tr>
                     <td width="30%">Terbilang</td>
                     <td className="leftAlign" align="left">&nbsp;:&nbsp;{terbilang(count)}</td>
                  </tr>
                  <tr>
                     <td colSpan="2"><i>Dengan rincian penerimaan sebagai berikut</i> :</td>
                  </tr>
               </tbody>
            </table>
            <table border="1" align="center" style={styletb}>
               <tbody>            
                  <tr align="left" style={{background:'#e5e5e5',padding:'4px'}}>
                     <th width="5%" style={{padding:'4px'}}>No.</th>
                     <th width="15%" style={{padding:'4px'}}>Rekening</th>
                     <th width="60%" style={{padding:'4px'}}>Uraian</th>
                     <th width="25%" style={{padding:'4px'}} align="right">Jumlah (Rp.)</th>
                  </tr>
                  {data.bp.map((item,i)=>(
                     item.rincian.map((rek,ii)=>{
                        counter = counter + 1
                        
                        return (<tr key={counter}>
                           <td style={{padding:'4px'}} width="5%">{counter}.</td>
                           <td style={{padding:'4px'}} width="15%">{`${rek.kd_rek_1}.${rek.kd_rek_2}.${rek.kd_rek_3}.${rek.kd_rek_4}.${rek.kd_rek_5}`}</td>
                           <td style={{padding:'4px'}} width="60%">
                              <p>{ rek.uraian_rinc }</p>
                              {/*<p>{ item.uraian }</p>*/}
                           </td>
                           <td style={{padding:'4px'}} width="25%" align="right">
                              {toIDR(rek.nilai)}
                           </td>
                        </tr>)
                     })
                  ))}
                  <tr style={{background:'#e5e5e5'}}>
                     <td style={{padding:'4px'}} colSpan="4" align="right">
                        {toIDR(count)}
                     </td>
                  </tr>
                  <tr>
                     <td style={{padding:'4px'}} colSpan="4" align="right">
                        <i>{terbilang(count)}</i>
                     </td>
                  </tr>
               </tbody>            
            </table>
            <table align="center" width="80%" style={{marginTop:'25px'}}>
               <tbody>
                  <tr align="left">
                     <td colSpan="2">Diterima pada : </td>
                  </tr>
               </tbody>
            </table>

               <table align="center" width="80%" style={{marginTop:'30px'}}>
                  <tbody>
                     <tr align="center">
                        <td colSpan="2">
                           Pegawai/Pejabat yang menyetujui<br />
                           {data.paraf.jabatan}<br />
                           <u>{data.paraf.nama}</u><br />
                           {data.paraf.kode}<br />
                        </td>
                     </tr>
                     <tr align="center">
                        <td colSpan="2">
                           {/*<u>{data.paraf.nama}</u><br />
                  {data.paraf.kode}<br />*/}
                        </td>
                     </tr>
                  </tbody>
               </table>
            </div>
            <Button
               content='Verifikasi' 
               primary 
               icon='pointing up'
               loading={this.state.loading}
               disabled={this.state.disable_btn}
               onClick={()=>this.verifikasiSTS(this.state.q)}
            />
         </Segment>
      )
   }

   verifikasiSTS(no_sts){
      
      swal({
         title: "Apakah anda yakin?",
         text: "STS ini akan diverifikasi, dan langsung divalidasi ke server SIMDA!",
         icon: "warning",
         buttons: true,
         dangerMode: true,
      })
      .then((verif) => {
         if (verif) {
            this.setState({requests:true});
            fetch(`${BaseURLDev}/postsimda/verifikasi`,{
               method: 'POST',
               headers,
               body: JSON.stringify({
                  no_sts: no_sts,
                  date: null
               })
            })
            .then(response => {
               if (!response.ok) { 
                  this.setState({requests:false});
                  swal("Verifikasi STS gagal", {
                     icon: "error",
                  });
                  return Promise.reject(response.statusText);
               }
               return response.json()
            })
            .then(parsedJSON => {
               this.setState({
                  data:{
                     ...this.state.data,
                     is_verified: true
                  },
                  requests: false
               });
               swal("Verifikasi STS selesai", {
                  icon: "success",
               }).then(()=>{
                  window.location.href="/c/dashboard"
               });
            })
         } else {
            return false
         }
      });
   }

   _handleKeyPress = (e) => {
      if (e.key === 'Enter') {
         this.searchSts(this.state.q)
      }
    }

   render() {
      const { requests } = this.state;
      
      return (
         <div style={{marginTop:'20px'}}>
            <div>
               <Menu>
                  <Menu.Item>
                     <Input type="text"
                        ref={(input) => {
                           this.codeInput = input
                        }}
                        icon="search"
                        placeholder="Masukkan Nomor STS"
                        autoFocus 
                        value={this.state.q}
                        style={{width:'300px',height:'40px'}}
                        onKeyPress={this._handleKeyPress} 
                        onChange={(e)=>this.setState({q:e.target.value})} 
                     />
                  </Menu.Item>
               </Menu>

               {requests && <Loader active inline='centered' size='large'>Loading...</Loader>}

               {this.state.data===null ? "" : this.showDetailSTS(this.state.data)}
         </div>
      </div>
      );
   }
}


// WEBPACK FOOTER //
// ./src/components/Content/DashboardBank.js